import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=e7e0acb0&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"
import style0 from "./privacy.vue?vue&type=style&index=0&id=e7e0acb0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e0acb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/hybrid-app/ph-refusaldrainage-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7e0acb0')) {
      api.createRecord('e7e0acb0', component.options)
    } else {
      api.reload('e7e0acb0', component.options)
    }
    module.hot.accept("./privacy.vue?vue&type=template&id=e7e0acb0&scoped=true", function () {
      api.rerender('e7e0acb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/privacy.vue"
export default component.exports